export default class FormuleArchivesController {
	/* @ngInject */
	constructor($state, $stateParams, FormuleService, ModalService, notification, $translate, $uibModal, globalizationManagementService, _, moment) {
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.FormuleService = FormuleService;
		this.ModalService = ModalService;
		this.notification = notification;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this._ = _;

		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
		this.displayDateMask = globalizationManagementService.getCurrentLanguage().displayDateMask;
		this.moment = moment;
	}

	$onInit() {
		const archives = angular.copy(this.formules.liste);

		/* if (typeof this.formules.liste != 'undefined') {
            archives.pop();
        } */
		this.archives = archives
			.filter((e) => e.dateArchivage !== null)
			.sort((a, b) => {
				return this.moment(b.dateArchivage, `${this.dateFormat} HH:mm`) - this.moment(a.dateArchivage, `${this.dateFormat} HH:mm`);
			});
	}

	async openVisualisation(id) {
		if (id) {
			let formuleArchiver = await this.FormuleService.getFormuleById(id);
			const nextFormule = await this.checkNextCompo(id, this.archives);
			formuleArchiver = await this.checkChanges(formuleArchiver, nextFormule);
			const modalInstance = this.$uibModal.open({
				component: 'visualisation',
				resolve: {
					formule: () => formuleArchiver,
					produit: () => this.produit
				},
				backdrop: false,
				size: 'xxl'
			});

			return modalInstance.result;
		}
	}

	/* openVisualisation(id) {
        var _this = this;
        let source = null;
        for (let i = 0; i < this.archives.length; i++) {
            if (this.archives[i].idComposition === id) {
                source = this.archives[i];
                break;
            }
        }
        _this.source = source;
        this.$uibModal
            .open({
                template: '<visualisation source="$ctrl.source" modal-instance="$ctrl.uibModalInstance"></visualisation>',
                controller: [
                    '$uibModalInstance',
                    function ($uibModalInstance) {
                        var $ctrl = this;
                        $ctrl.source = _this.source;
                        $ctrl.uibModalInstance = $uibModalInstance;
                    }
                ],
                controllerAs: '$ctrl',
                size: 'xxl'
            })
            .result.then(
                function (result) {
                    // console.info("I was closed, so do what I need to do myContent's controller now.  Result was->");
                    // console.info(result);
                },
                function (reason) {
                    // console.info("I was dimissed, so do what I need to do myContent's controller now.  Reason was->" + reason);
                }
            );
    } */

	async deleteArchive(archive) {
		try {
			await this.FormuleService.deleteArchiveById(archive.idComposition);
			const index = this.archives.indexOf(archive);
			this.archives.splice(index, 1);
			this.notification.success(this.$translate.instant('FORMULES.DELETE.ARCHIVE_SUCCESS'));
		} catch (err) {
			this.notification.error(err.data);
		}

		// var _this = this;
		// console.log(_this);

		// if (archive  && archive.idComposition) {
		//     const modalInstance = this.ModalService.confirm({
		//         modalTitle: this.$translate.instant('OFFRES.DELETE.TITLE', {code: archive.codeComposition}),
		//         modalMsg: this.$translate.instant('OFFRES.DELETE.MESSAGE'),
		//         headerClass: 'modal-danger'
		//     });

		//     modalInstance.result
		//         .then(async function(_this) {
		//             try {
		//                 console.log(_this);
		//                 await _this.FormuleService.deleteArchiveById(archive.idComposition);
		//                 //_this.notification.success(this.$translate.instant('OFFRES.DELETE.SUCCESS'));
		//             } catch (ex) {
		//                 //_this.notification.error(ex.data);
		//             }
		//         }, this);
		// }
	}

	async checkNextCompo(id, listArchives) {
		if (!listArchives?.length) return null;

		const idx = listArchives.findIndex((item) => item.idComposition === id);

		// Si idx === 0 on prend this.formule (formule courante), sinon l'élément précédent dans la liste (l'archive precedente)
		const nextCompo = idx === 0 ? this.formule : listArchives[idx - 1];

		if (!nextCompo) return null;

		return await this.FormuleService.getFormuleById(nextCompo.idComposition);
	}

	async checkChanges(formuleArchiver, nextFormule) {
		if (!formuleArchiver || !nextFormule) return formuleArchiver;
		if (!formuleArchiver.composants) formuleArchiver.composants = [];

		// On regarde ce qui existe dans l'archive
		formuleArchiver.composants.forEach((composant) => {
			composant.propHasChanged = [];

			// On cherche si ce composant existe encore dans la version suivante
			const keepedC = nextFormule.composants?.find((c) => c.idComposant === composant.idComposant && c.idProducteur === composant.idProducteur);

			composant.keeped = !!keepedC; // False = Supprimé

			if (keepedC) {
				// S'il existe toujours, on compare les valeurs
				this.compareComposantProperties(composant, keepedC);
			}
		});

		// On regarde ce qui existe dans la nouvelle formule mais PAS dans l'archive (nouveau composant)
		if (nextFormule.composants) {
			nextFormule.composants.forEach((nextC) => {
				const existsInArchive = formuleArchiver.composants.some(
					(archC) => archC.idComposant === nextC.idComposant && archC.idProducteur === nextC.idProducteur
				);

				if (!existsInArchive) {
					// nouveau composant : On l'ajoute à la liste de l'archive pour pouvoir l'afficher,
					// en le marquant comme 'newcomp'.
					const newComponentEntry = {
						...nextC,
						newcomp: true,
						propHasChanged: [],
						keeped: true
					};

					formuleArchiver.composants.push(newComponentEntry);
				}
			});
		}

		return await this.checkChangesCompo(formuleArchiver, nextFormule);
	}

	compareComposantProperties(composant, keepedC) {
		for (const prop in keepedC) {
			const valNext = keepedC[prop];
			const valArch = composant[prop];

			if (prop === 'prix' && valNext !== null) {
				if (valArch === null || valNext.valeur !== valArch.valeur) {
					composant.propHasChanged.push(prop);
				}
				continue;
			}

			if (prop === 'valeursDeRef' && valNext !== null) {
				if (!Array.isArray(valArch)) {
					if (valNext.length > 0) composant.propHasChanged.push(prop);
				} else if (Array.isArray(valNext)) {
					valNext.forEach((ref, i) => {
						if (!valArch[i] || ref.valeur !== valArch[i].valeur) {
							composant.propHasChanged.push(ref.codeEssai);
						}
					});
				}
				continue;
			}

			if (valNext !== valArch) {
				composant.propHasChanged.push(prop);
			}
		}
	}

	async checkChangesCompo(formuleArchiver, nextFormule) {
		formuleArchiver.propHasChanged = [];

		for (const prop in formuleArchiver) {
			const valArch = formuleArchiver[prop];
			const valNext = nextFormule[prop];

			if ((valArch === null || valArch === undefined) && (valNext === null || valNext === undefined)) {
				continue;
			}

			if (prop === 'normeSpec') {
				const idArch = valArch ? valArch.id : null;
				const idNext = valNext ? valNext.id : null;

				if (idArch !== idNext) {
					formuleArchiver.idNormeNextCompo = idNext;
					formuleArchiver.propHasChanged.push(prop);
				}
			} else if (prop === 'squelette') {
				const idArch = valArch ? valArch.idComposition : null;
				const idNext = valNext ? valNext.idComposition : null;

				if (idArch !== idNext) {
					formuleArchiver.propHasChanged.push(prop);
				}
			} else if (valArch !== valNext) {
				formuleArchiver.propHasChanged.push(prop);
			}
		}

		return formuleArchiver;
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	startCodeLoading() {
		this.codeLoading = true;
	}

	stopCodeLoading() {
		this.codeLoading = false;
	}
}
